<!--模板界面-->
<template>
	<div class="dyin_center">
		<!--头部-->
		<div class="deyin_center_top">
			<div class="deyin_center_div topDiv">
				<p>本月用电</p>
				<p><span>{{powerData.month}}</span>(KWh)</p>
			</div>
			<div class="deyin_center_div topDiv">
				<p>上月用电</p>
				<p><span>{{powerData.lasMonth}}</span>(KWh)</p>
			</div>
			<div class="deyin_center_div topDiv">
				<p>今日用电</p>
				<p><span>{{powerData.day}}</span>(KWh)</p>
			</div>
			<div class="deyin_center_div topDiv">
				<p>昨日同期</p>
				<p><span>{{powerData.lasDay}}</span>(KWh)</p>
			</div>
		</div>
		<!--中间-->
		<div class="deyin_center_center">
			<div id="deyinMap" ref="deyinMapEchart"></div>
		</div>
		<!--底部-->
		<div class="deyin_center_bottom">
			<div class="deyin_center_divLeft">
			</div>
			<!--电量对比-->
			<div class="deyin_center_div bottomDiv">
				<vchart ref='thatDayVchart'></vchart>
			</div>
			<!--当日电量-->
			<div class="deyin_center_div bottomDiv">
				<vchart ref='peakVchart'></vchart>
			</div>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	import echarts from "echarts";
	import '../../../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
	import '../../../../../public/static/js/renkouqianxi.js'
	export default {
		components: {
			vchart,
		},
		props: {},
		data() {
			return {
				powerData: {
					lasLastMonth: 0, //上上月
					month: 0, //本月用电量
					lasMonth: 0, //上月用电量
					day: 0, //今日用电量
					lasDay: 0, //昨日用电量
				},
				thatDayOption: {
					title: [{
						text: '电量对比',
						textStyle: {
							color: "white"
						},
						top: '5%',
						left: '5%'
					}, {
						subtext: '(单位:次)',
						subtextStyle: {
							color: "white",
							fontSize: '15',
						},
						top: '2%',
						left: '30%'
					}],
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						textStyle: {
							color: 'white'
						},
						top: '15%'
					},
					grid: [{
						bottom: '10%',
						left: '15%',
						height: 170,
					}],
					xAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: 'white'
							}
						},
						axisLine: {
							lineStyle: {
								color: 'white',
							}
						},
						data: []
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: false,
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: 'white'
							}
						},
						axisLine: {
							lineStyle: {
								color: 'white',
							}
						},
					},
					series: [{
						name: '今日总电量',
						data: [],
						type: 'bar',
						barMaxWidth: '25',
						itemStyle: {
							normal: {　
								color: "#4cb8f5"
							}
						}
					}, {
						name: '昨日总电量',
						data: [],
						type: 'bar',
						barMaxWidth: '25',
						itemStyle: {
							normal: {　
								color: "#ff6f65"
							}
						}
					}, ]

				},
				peakOption: {
					title: [{
						text: '当日电量',
						textStyle: {
							color: "white"
						},
						top: '5%',
						left: '5%'
					}, {
						subtext: '(单位:KW.h)',
						subtextStyle: {
							color: "white",
							fontSize: '15',
						},
						top: '2%',
						left: '30%'
					}],
					tooltip: {
						trigger: 'axis'
					},
					grid: [{
						bottom: '10%',
						left: '15%',
						height: 170,
					}],
					xAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: 'white'
							}
						},
						axisLine: {
							lineStyle: {
								color: 'white',
							}
						},
						data: []
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: false,
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: 'white'
							}
						},
						axisLine: {
							lineStyle: {
								color: 'white',
							}
						},
					},
					series: [{
						data: [],
						type: 'bar',
						barMaxWidth: '25',
					}]

				},
			}
		},
		created() {},
		mounted() {
			this.thatDayOption.xAxis.data = this.twentyFourData
			this.peakOption.xAxis.data = this.twentyFourData
			/*this.deyinMapData()*/
			setTimeout(() => {
				this.initData()
			}, 1000);
			this.initDataPower(this.nowUnit.id)
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			twentyFourData() {
				//x轴的24小时数据
				let list = []
				for(let i = 0; i <= new Date().format('hh'); i++) {
					if(i < 10) {
						list.push('0' + i + ":00")
					} else {
						list.push(i + ":00")
					}
				}
				return list
			}
		},
		watch: {
			nowUnit(nv,ov){
				this.initDataPower(this.nowUnit.id)
			}
		},
		methods: {
			initDataPower(unitId) {
				if(isempty(unitId)){
					return 
				}
				//获取本月用电量
				var now = new Date()
				var nowTime = now.getTime()
				var year = now.getFullYear()
				var month = now.getMonth()
				var day = now.getDate()
				var nowZero = new Date(year, month, day).getTime()
				this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, month, 1).getTime(), nowTime, respon => {
					this.powerData.month=Number(respon)
				})
				//获取上月用电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, month - 1, 1).getTime(), new Date(year, month - 1, 31)
					.getTime() -
					1, respon => {
						this.powerData.lasMonth =Number(respon)
					}, repon => {
						this.powerData.lasMonth = 0
					})
			},
			initData() {
				let year = new Date().format('yyyy')
				let month = new Date().format('MM')
				let day = new Date().format('dd')
				//查询单位下的能耗设备
				this.$api.deviceApi.getDeviceByUnitIdAndDeviceType(this.nowUnit.id, "power", respon => {
					if(!isempty(respon)) {
						let deviceNos = ""
						let powerDeviceName = ""
						respon.forEach((item, i) => {
							if(i < respon.length - 1) {
								deviceNos += item.no + ','
								powerDeviceName += item.name + '.总有功电能' + ','
							} else {
								powerDeviceName += item.name + '.总有功电能'
								deviceNos += item.no
							}
						})
						//查询看板用电量
						this.$api.powerApi.getUnitUsePower(this.nowUnit.id, deviceNos, respon2 => {
							this.powerData.day = respon2.day
							this.powerData.lasDay = respon2.lastDay
						})
						/*查询上上月用电量*/
						let lasLasMonth = new Date()
						if(month - 2 > 0) {
							lasLasMonth = new Date(year + "-" + month)
						} else {
							lasLasMonth = new Date(year - 1 + "-" + (12 + (month - 2)))
						}
						let bgTime = new Date(lasLasMonth + "-01").getTime()
						let endTime = new Date(lasLasMonth + "-31").getTime()
						this.$api.powerApi.getUnitUsePowerByDate(this.nowUnit.id, bgTime, endTime, respon => {
							this.powerData.lasLastMonth = respon
						})
						//查询今日昨日用电量
						this.$api.historyApi.searchVariableHistory(powerDeviceName, new Date(getDay(-1) + " 00:00:00").getTime(), new Date().getTime(), repson2 => {
							if(!isempty(repson2)) {
								//处理数据
								let data = []
								let data2 = []
								let thatDayseriesData = []
								let day = new Date().format("yyyyMMdd")
								let lasDay = getDay(-1, "")
								for(let key in repson2) {
									let thatDayData = []
									for(let i = 0; i < 288; i += 12) {
										//求差值
										let v1 = repson2[key][day].data[i]
										let v2 = repson2[key][day].data[i + 12]
										let lasv1 = repson2[key][lasDay].data[i]
										let lasv2 = repson2[key][lasDay].data[i + 12]
										if(!isempty(v2) && !isempty(v1)) {
											data.push(v2 - v1)
											thatDayData.push(v2 - v1)
										} else {
											data.push(0)
											thatDayData.push(0)
										}
										if(!isempty(lasv2) && !isempty(lasv1)) {
											data2.push(lasv2 - lasv1)
										} else {
											data2.push(0)
										}
									}
									let obj = {
										name: key.split('.')[0],
										type: 'bar',
										data: thatDayData
									}
									thatDayseriesData.push(obj)
								}
								let ser24Data = []
								let ser24Data2 = []
								//24小时的数据
								for(let i = 0; i < 24; i++) {
									ser24Data.push(data[i] + data[i + 24])
									ser24Data2.push(data2[i] + data2[i + 24])
								}
								//只显示当前整点时间的
								let serData = []
								let serData2 = []
								for(let i = 0; i <= new Date().format('hh'); i++) {
									serData.push(ser24Data[i])
									serData2.push(ser24Data2[i])
								}
								//当日电量显示当前时间的值
								thatDayseriesData.forEach((item, i) => {
									let data = []
									for(let j = 0; j <= new Date().format('hh'); j++) {
										data.push(item.data[j])
									}
									thatDayseriesData[i].data = data
								})
								//当日总电量
								let powerTotal = []
								thatDayseriesData.forEach((item, i) => {
									item.data.forEach((item2, i2) => {
										if(isempty(powerTotal[i2])) {
											powerTotal.push(item2)
										} else {
											powerTotal[i2] = powerTotal[i2] + item2
										}
									})

								})
								thatDayseriesData.push({
									name: "总电量",
									type: 'bar',
									data: powerTotal
								})
								this.thatDayOption.series[0].data = serData
								this.thatDayOption.series[1].data = serData2
								this.$refs.thatDayVchart.setData(this.thatDayOption)
								//总用电量
								this.peakOption.series = thatDayseriesData
								this.$refs.peakVchart.setData(this.peakOption)
							}

						})
					}
				})
			},
			deyinMapData() {
				let myChart = echarts.init(this.$refs.deyinMapEchart);
				window.onresize = myChart.resize;
				myChart.setOption({
					backgroundColor: 'rgba(0,0,0,0)',
					title: {
						show: false
					},
					tooltip: {
						trigger: 'item'
					},
					grid: [{
						bottom: '10%',
					}],
					legend: {
						orient: 'vertical',
						top: 'bottom',
						left: 'right',
						data: ['北京 Top10', '上海 Top10', '广州 Top10'],
						textStyle: {
							color: '#fff'
						},
						selectedMode: 'single'
					},
					geo: {
						map: 'china',
						label: {
							emphasis: {
								show: false
							}
						},
						zoom: 1.3,
						roam: true,
						itemStyle: {
							normal: {
								borderColor: '#3366cc',
								borderWidth: 1,
								borderType: 'solid',
								areaColor: '#0c0d49',
							},
							emphasis: {
								areaColor: '#0b1c2d'
							}
						}
					},
					series: series
				})

			}
		}
	}
</script>

<style scoped>
	.dyin_center {
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: space-between;
	}
	
	.deyin_center_top {
		width: 100%;
		height: 12%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.deyin_center_center {
		width: 100%;
		height: 55%;
	}
	
	.deyin_center_bottom {
		width: 100%;
		height: 30%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.deyin_center_divLeft {
		width: 20%;
		height: 100%;
	}
	
	.deyin_center_div {
		background-image: url(../../../../../public/static/image/科技蓝/deyin/rateBoxBg.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	
	.topDiv {
		width: 24%;
		height: 100%;
	}
	
	.bottomDiv {
		width: 38%;
		height: 100%;
	}
	
	.deyin_center_div p {
		color: white;
		line-height: 30px;
	}
	
	.deyin_center_div p:nth-child(2) {
		color: #4bc0d1;
	}
	
	.deyin_center_div p:nth-child(2) span {
		font-size: 25px;
		line-height: 30px;
	}
	
	.loadTitile {
		position: absolute;
		bottom: 2%;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
	
	.loadTitile p {
		font-size: 20px;
	}
	
	.loadTitile p:nth-child(2) {
		font-size: 30px;
	}
	
	#deyinMap {
		width: 100%;
		height: 100%;
		background-image: url(../../../../../public/static/image/科技蓝/deyin/content.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
</style>